import React from 'react'
import Search from '../../components/Search/Search'
import './Wikis.css'

const Wikis = () => {
    return (
        <div className="wikis">
            <Search />
        </div>
    )
}

export default Wikis
